export default __webpack_public_path__ + "static/page-based-528572371194c996bb637ed823dddec6.png";